import USDCIcon from "../components/icons/usdc";

// This file contains constant configurion values for the application
export const API_URL = import.meta.env.VITE_API_URL;
export const MODE = import.meta.env.MODE;

export const EXPERIMENTAL_ISOLATED_MARGIN =
  import.meta.env.VITE_EXPERIMENTAL_ISOLATED_MARGIN === "true";

export const Zeno = {
  httpUrl: import.meta.env.VITE_ZENO_HTTP_URL,
  wsUrl: import.meta.env.VITE_ZENO_WS_URL,
};

export const Feesigner = {
  httpUrl: import.meta.env.VITE_FEESIGNER_URL,
};

export const Auth = {
  environmentId: import.meta.env.VITE_DYNAMIC_ENVIRONMENT_ID,
};

export const Funding = {
  minCollateralDepositAmount: import.meta.env
    .VITE_FUNDING_MIN_COLLATERAL_DEPOSIT_AMOUNT,
};

export const Blockchain = {
  blockExplorerUrl: import.meta.env.VITE_BLOCKCHAIN_EXPLORER_URL,
  rpcUrl: import.meta.env.VITE_BLOCKCHAIN_RPC_URL,
  wsUrl: import.meta.env.VITE_BLOCKCHAIN_WS_URL,
  env: import.meta.env.VITE_BLOCKCHAIN_SDK_ENV,
  usdcMintAddress: import.meta.env.VITE_BLOCKCHAIN_USDC_MINT_ADDRESS,
};

export const Gordon = {
  dlobWS: import.meta.env.VITE_DLOB_WS_URL,
  dlobHTTP: import.meta.env.VITE_DLOB_HTTP_URL,
  apiUrl: import.meta.env.VITE_MASH_API_URL,
};

export const Mash = {
  initialCollateralAmount: import.meta.env.VITE_MASH_INITIAL_COLLATERAL_AMOUNT,
  defaultSubaccountName: import.meta.env.VITE_MASH_DEFAULT_SUBACCOUNT_NAME,
};

export const Misc = {
  registerEmailUrl:
    import.meta.env.VITE_MISC_REGISTER_EMAIL_URL ||
    "https://gordon-api.devnet.mash.trade/closed_beta/register",
  referrerBase: import.meta.env.VITE_REFERRER_BASE || "https://mash.fun",
  sentryDSN: import.meta.env.VITE_SENTRY_DSN,
  vaultAddress: import.meta.env.VITE_VAULT_ADDR,
};

export const Tokens = {
  USDC: {
    symbol: "USDC",
    Icon: USDCIcon,
  },
};

export const ErrorMessages = {
  MARKET_NOT_FOUND: "Market not found",
  NO_ACTIVE_MARKETS: "No active markets",
  FATAL_ERROR: "Unexpected error occurred",
  INITIALIZATION_ERROR: "Initialization error",
  PAGE_NOT_FOUND: "Page not found",
};

export const PrimaryVault = {
  vaultAddress:
    import.meta.env.VITE_VAULT_ADDR ||
    "7NePfmhUDY8gmxbuRMdmVQW7osnA7R6opzQSP9swry8G", // devnet
  vaultLutAddress:
    import.meta.env.VITE_VAULT_LUT_ADDR ||
    "GsZBMkswJKBBdemC7mXmRiMgbaYMmyMShP9s1uHremLR", // devnet
};

export const MashExplorer = {
  API_URL:
    import.meta.env.VITE_MASH_EXPLORER_API_URL ||
    "https://explore.devnet.mash.trade",
};
